import React from 'react';

import { Alert } from '@mui/material';

interface ErrorLayoutProps {
  data: any;
  error: any;
  children: React.ReactChild;
}

export default function ErrorLayout({ data, children }: ErrorLayoutProps) {
  return (
    <>
      {data ? children : <Alert severity='error'>Failed to fetch data</Alert>}
    </>
  );
}
